import CommandeSingle from '../../views/CommandeSingle';
import QuizSingle from '../../views/QuizSingle';
import ProductSingle from '../../views/ProductSingle';
import Commande from '../../views/Commande';
import pages from '../pages';
import { Route } from '../routes';
import { RecapQuizClasse } from '../../views/RecapQuizClasse';
import { PedagogicalChallengeSingle } from 'views/PedagogicalChallengeSingle';

export const singleRoutes: Route[] = [
  {
    path: pages.COMMANDE_SINGLE_PAGE.path,
    component: CommandeSingle
  },
  {
    path: pages.QUIZ_SINGLE_PAGE.path,
    component: QuizSingle
  },
  {
    path: pages.PRODUCT_SINGLE_PAGE.path,
    component: ProductSingle
  },
  {
    path: pages.PEDAGOGICAL_CHALLENGE_SINGLE.path,
    component: PedagogicalChallengeSingle
  },
  {
    path: pages.COMMANDE_PAGE.path,
    component: Commande
  },
  {
    path: pages.RECAP_QUIZ_CLASSE_PAGE.path,
    component: RecapQuizClasse
  }
];
